import { Action } from '@ngrx/store';
import { AlertsState, Alert } from '../../typings/alerts';
import { Language } from '../../typings/language';
import { ILegalEntity } from '@cemex-core/cmx-api/models/legal-entities/legal-entity';
import { AuthState } from '../../typings/auth';
import { Parameters } from '../../typings/parameters';
import { ICopyright } from '../../typings/copyright';
import { Direction } from '../../cmx-layout/types/directions';

export enum AppActionsTypes {
  SET_MOBILE = '[App] Set Mobile',
  AUTH_RESTORE = '[App] Restore auth state',
  SET_LOADER = '[App] Set global loader',
  LOGIN_START = '[App] Login start',
  LOGIN_SUCCESS = '[App] Login success',
  LOGIN_ERROR = '[App] Login error',
  SET_LANGUAGE = '[App] Set Language',
  SET_LANGUAGES = '[App] Set Languages',
  UPDATE_ALERTS = '[App] Update Alerts',
  SET_LEGAL_ENTITY = '[App] Set Active Legal Entity',
  INITIALIZE = '[App] App Layout initialized and ready to use',
  SET_DIRECTION = '[App] Set direction',
  ADD_ALERT = '[App] Add Alert',
  REMOVE_ALERT = '[App] Remove Alert',
  SET_VERSION = '[App] Set version',
  SET_PARAMETERS = '[App] Set parameters',
  SET_COPYRIGHT = '[App] Set copyright',
}

export class SetMobile implements Action {
  readonly type = AppActionsTypes.SET_MOBILE;

  constructor(public payload: boolean) {}
}

export class AuthRestore implements Action {
  readonly type = AppActionsTypes.AUTH_RESTORE;

  constructor(public payload: AuthState) {}
}

export class SetLoader implements Action {
  readonly type = AppActionsTypes.SET_LOADER;

  constructor(public payload: boolean) {}
}

export class LoginStart implements Action {
  readonly type = AppActionsTypes.LOGIN_START;
}

export class LoginSuccess implements Action {
  readonly type = AppActionsTypes.LOGIN_SUCCESS;

  constructor(public payload: AuthState) {}
}

export class LoginError implements Action {
  readonly type = AppActionsTypes.LOGIN_ERROR;
}

export class SetLanguage implements Action {
  readonly type = AppActionsTypes.SET_LANGUAGE;

  constructor(public payload: string) {}
}

export class SetLanguages implements Action {
  readonly type = AppActionsTypes.SET_LANGUAGES;

  constructor(public payload: Language[]) {}
}

export class UpdateAlerts implements Action {
  readonly type = AppActionsTypes.UPDATE_ALERTS;

  constructor(public payload: AlertsState) {}
}

export class SetLegalEntity implements Action {
  readonly type = AppActionsTypes.SET_LEGAL_ENTITY;

  constructor(public payload: ILegalEntity) {}
}

export class Initialize implements Action {
  readonly type = AppActionsTypes.INITIALIZE;
}

export class SetDirection implements Action {
  readonly type = AppActionsTypes.SET_DIRECTION;

  constructor(public payload: Direction) {}
}

export class AddAlert implements Action {
  readonly type = AppActionsTypes.ADD_ALERT;

  constructor(
    public target: string,
    public alert: Alert,
  ) {}
}

export class RemoveAlert implements Action {
  readonly type = AppActionsTypes.REMOVE_ALERT;

  constructor(
    public target: string,
    public id: number,
  ) {}
}

export class SetVersion implements Action {
  readonly type = AppActionsTypes.SET_VERSION;

  constructor(public payload: number) {}
}

export class SetParameters implements Action {
  readonly type = AppActionsTypes.SET_PARAMETERS;

  constructor(public payload: Parameters[]) {}
}

export class SetCopyright implements Action {
  readonly type = AppActionsTypes.SET_COPYRIGHT;

  constructor(public payload: ICopyright[]) {}
}

export type AppActions =
  | SetMobile
  | AuthRestore
  | SetLoader
  | LoginStart
  | LoginSuccess
  | LoginError
  | SetLanguage
  | SetLanguages
  | UpdateAlerts
  | SetLegalEntity
  | Initialize
  | SetDirection
  | AddAlert
  | RemoveAlert
  | SetVersion
  | SetParameters
  | SetCopyright;
